export const emergentReaderSubjects = ["alphabet", "awareness"] as const

export type EmergentReaderSubjects = typeof emergentReaderSubjects[number]


export type PageType = "Oral Expression" | "Prep" | ResponseType

export const responseTypes = ["Timed Activity", "Untimed Activity"] as const
export type ResponseType = typeof responseTypes[number]
